import React from "react";

/**
 *
 * @param {*} text The emoji in unicode
 * @returns image src of the emoji with onClick function
 */
export default function Emoji({unicodeEmoji, onClick, padding, width, height}) {

    // Convert unicode emoji to codepoint

    function emojiToCodePoint(emoji) {
        // Split the emoji into its individual code units and map to hexadecimal
        return Array.from(emoji)
          .map(char => char.codePointAt(0).toString(16))
          .join('-');
    }
    // Find path to twitter emoji image based on unicode emoji
    const options = {
        baseUrl: "/twemoji/",
        size: "72x72",
        ext: "png",
      };
    const separator = options.size ? "/" : "";

    let codepoint = emojiToCodePoint(unicodeEmoji);
    if (!codepoint) return <div onClick={onClick}>unicodeEmoji</div>; // Failed, return clickable unicode emoji

    let src = `${options.baseUrl}${options.size}${separator}${codepoint}.${options.ext}`;
    return (
        <img src={src} alt="unicodeEmoji" style={{width: width ? width : "2em", height: height ? height : "2em", padding: padding ? padding : "0.2em 0.2em 0.2em 0.2em"}} onClick={onClick}/>
  );
}


// WEBPACK FOOTER //
// ./src/component/Emoji/index.js